import { PartialTranslation } from '../translations';

export const pl: PartialTranslation = {
  newChat: 'Nowy czat',
  search: 'Szukaj',
  user: 'Użytkownik',
  settings: 'Ustawienia',
  language: 'Język',
  getHelp: 'Uzyskaj pomoc',
  viewAllPlans: 'Zobacz wszystkie plany',
  learnMore: 'Dowiedz się więcej',
  logOut: 'Wyloguj się',
  chooseLanguage: 'Wybierz język',
  chooseYourPreferredLanguage: 'Wybierz preferowany język',
  searchLanguages: 'Szukaj języków...',
  autoDetect: 'Automatyczne wykrywanie',
  noLanguagesFound: 'Nie znaleziono języków',
  askAnything: 'Zapytaj o cokolwiek',
  lawhelperAi: 'Lawhelper.ai',
  personal: 'Osobisty',
  freePlan: 'Plan darmowy',
  current: 'Aktualny',
  close: 'Zamknij',
  archive: 'Archiwizuj',
  delete: 'Usuń',
  confirmDelete: 'Czy na pewno chcesz usunąć tę rozmowę?',
  confirmArchive: 'Czy na pewno chcesz zarchiwizować tę rozmowę?',
  deleteCannotUndo: 'Tej czynności nie można cofnąć.',
  archiveCanFind: 'Po zarchiwizowaniu znajdziesz ją na liście archiwum.',
  // 资源面板
  resources: 'Zasoby',
  addResource: 'Dodaj zasób',
  deleteResource: 'Usuń zasób',
  noMatchingResourcesFound: 'Nie znaleziono pasujących zasobów',
  noResourcesAvailable: 'Brak dostępnych zasobów',
  hideResources: 'Ukryj zasoby',
  showResources: 'Pokaż zasoby',
  
  // 聊天输入框
  typeMessage: 'Wpisz wiadomość...',
  thinkingOptions: 'Opcje myślenia',
  deleteFile: 'Usuń plik',
  clearSelection: 'Wyczyść wybór',
  
  // 思考模式选项
  deepInsight: 'Głęboki wgląd · Analiza powierzchniowa',
  deepInsightDesc: 'Szybkie zrozumienie kluczowych punktów',
  deepExploration: 'Głęboka eksploracja · Analiza kompleksowa',
  deepExplorationDesc: 'Wielowymiarowe dogłębne badanie',
  deepDeconstruction: 'Głęboka dekonstrukcja · Argument systematyczny',
  deepDeconstructionDesc: 'Progresywna analiza warstwa po warstwie',
  
  // 写作模式选项
  contractReview: 'Przegląd umowy · Identyfikacja ryzyka',
  contractReviewDesc: 'Analiza klauzul i sprawdzenie zgodności',
  textPolish: 'Polerowanie tekstu · Profesjonalne wyrażanie',
  textPolishDesc: 'Optymalizacja języka i dostosowanie struktury',
  legalDocuments: 'Dokumenty prawne · Standardowe sporządzanie',
  legalDocumentsDesc: 'Profesjonalne pisanie dokumentów prawnych',
  addAttachment: 'Dodaj załącznik',
  sendMessage: 'Wyślij wiadomość',

  // 认证和隐私翻译 (English fallback - needs translation)
  login: 'Zaloguj się',
  register: 'Zarejestruj się',
  welcomeBack: 'Witamy w LawHelper',
  loginSubtitle: 'Twój Asystent AI do Badań Prawnych',
  continueWithGoogle: 'Kontynuuj z Google',
  continueWithMicrosoft: 'Kontynuuj z Microsoft',
  continueWithWeChat: 'Kontynuuj z WeChat',
  orContinueWith: 'lub kontynuuj z',
  emailTab: 'E-mail',
  phoneTab: 'Telefon',
  emailPlaceholder: 'Wprowadź swój e-mail',
  phonePlaceholder: 'Wprowadź numer telefonu',
  codePlaceholder: 'Wprowadź 6-cyfrowy kod',
  sending: 'Wysyłanie...',
  verifying: 'Weryfikacja...',
  verify: 'Zweryfikuj',
  sendMagicLink: 'Wyślij magiczny link',
  getVerificationCode: 'Pobierz kod',
  resendCode: 'Wyślij ponownie',
  resendIn: 'Wyślij ponownie za',
  magicLinkSent: 'Magiczny link wysłany na Twój e-mail',
  magicLinkHint: 'Wyślemy bezpieczny link na Twój e-mail',
  otpSent: 'Kod weryfikacyjny wysłany',
  agreeToTerms: 'Kontynuując, zgadzasz się na',
  privacyPolicy: 'Polityka Prywatności',
  termsOfService: 'Warunki Usługi',
  and: 'i',
  privacyTitle: 'Twoja prywatność jest ważna',
  privacyIntro: 'Używamy plików cookie i podobnych technologii, aby zapewnić najlepsze wrażenia.',
  essentialCookies: 'Niezbędne pliki cookie',
  essentialDesc: 'Wymagane do działania strony',
  analyticsCookies: 'Analityczne pliki cookie',
  analyticsDesc: 'Pomagają nam ulepszać usługę',
  marketingCookies: 'Marketingowe pliki cookie',
  marketingDesc: 'Używane do spersonalizowanych treści',
  acceptAll: 'Zaakceptuj wszystkie',
  essentialOnly: 'Tylko niezbędne',
  customize: 'Dostosuj',
  savePreferences: 'Zapisz preferencje',
  back: 'Wstecz',
  readPrivacyPolicy: 'Przeczytaj naszą politykę prywatności',
  cookiePolicy: 'Polityka cookie',
  gdprCompliance: 'RODO',
  piplCompliance: 'PIPL',

  // AI工具面板
  aiReview: 'Przegląd AI',
  aiDraft: 'Szkic AI',
  smartAssistant: 'Szablon',

  // 知识库搜索
  enableKnowledgeSearch: 'Włącz wyszukiwanie',
  knowledgeSearchDesc: 'AI przeszukuje dokumenty',
  clickToDisable: 'Wyłącz',
  clickToEnable: 'Włącz',

  // Landing page translations
  tagline: 'AI-Powered Legal Intelligence',
  heroTitle1: 'Legal AI',
  heroTitle2: 'Simplified.',
  jurisdictionsLabel: 'Jurisdictions',
  accuracyLabel: 'Accuracy',
  fasterLabel: 'Faster',
  availableLabel: 'Available',
  platformCapabilities: 'Platform Capabilities',
  testimonialQuote: '"LawHelper has transformed how we handle legal work. Contract review is 10x faster, with incredible accuracy."',
  testimonialAuthor: 'Legal Professional',
  testimonialPosition: 'Partner at Top Law Firm',
  viewPricing: 'View Pricing',
  footerPricing: 'Pricing',
  footerPrivacy: 'Privacy',
  footerTerms: 'Terms',
  footerContact: 'Contact',
  footerCopyright: '© 2024 LawHelper. All rights reserved.',

  // Onboarding Guide
  onboardingWelcome: 'Welcome to Lawhelper.ai',
  onboardingSkip: 'Skip',
  onboardingNext: 'Next',
  onboardingPrev: 'Back',
  onboardingGetStarted: 'Get Started',
  onboardingSlide1Title: 'AI Legal Chat',
  onboardingSlide1Desc: 'Ask any legal question and get precise, jurisdiction-aware answers powered by advanced AI.',
  onboardingSlide2Title: 'Case Folder System',
  onboardingSlide2Desc: 'Organize your documents by case. Upload files and control which materials AI uses as context.',
  onboardingSlide3Title: 'Local Folder Access',
  onboardingSlide3Desc: 'Connect local directories in the browser. Preview, edit, and send files to AI chat.',
  onboardingSlide4Title: 'AI Drafting & Review',
  onboardingSlide4Desc: 'Draft legal documents with AI and review contracts to identify risks automatically.',
  onboardingGuide: 'Guide',
  mentionFiles: "Reference a file",

  // Auto-synced keys
  chats: 'Chats',
  archived: 'Archived',
  restore: 'Restore',
  noArchivedChats: 'No archived chats',
  backToChats: 'Back to Chats',
  closeResourcesPanel: 'Zamknij panel zasobów',
  uploading: 'Przesyłanie %{fileName}...',
  processing: 'Przetwarzanie %{fileName}...',
  uploadSuccess: '✓ %{fileName} przesłany',
  uploadError: '✗ Przesyłanie nie powiodło się: %{error}',
  quickAnswer: 'Szybka odpowiedź',
  quickAnswerDesc: 'Szybka odpowiedź na proste pytania',
  cancelRequest: 'Anuluj',
  library: 'Biblioteka',
  filterAll: 'Wszystko',
  filterChat: 'Czaty',
  filterReview: 'Przegląd',
  filterDraft: 'Szkic',
  filterTemplate: 'Szablon',
  filterForm: 'Formularz',
  thinking: 'Myślę...',
  thinkingProcess: 'Proces myślowy',
  analyzingLegalLogic: 'Analiza logiki prawnej...',
  lawhelperThinking: 'Lawhelper myśli...',
  serviceError: 'Błąd usługi',
  uploaded: 'Przesłano',
  settingsGeneral: 'Ogólne',
  settingsNotifications: 'Powiadomienia',
  settingsAppearance: 'Wygląd',
  settingsProfile: 'Profil',
  settingsResponseNotifications: 'Powiadomienia o odpowiedziach',
  settingsResponseNotificationsDesc: 'Powiadomienie po zakończeniu odpowiedzi AI',
  settingsColorMode: 'Tryb kolorów',
  settingsLight: 'Jasny',
  settingsDark: 'Ciemny',
  settingsSystem: 'System',
  about: 'O programie',
  reviewTitle: 'Przegląd dokumentu',
  exitReview: 'Zakończ przegląd',
  uploadPrompt: 'Prześlij PDF do przeglądu',
  uploadButton: 'Wybierz plik',
  startChatConfig: 'Wpisz "Przejrzyj ten dokument" aby rozpocząć',
  reviewPlaceholder: 'Wpisz wiadomość lub "Przejrzyj ten dokument"...',
  analyzing: 'Przeglądanie...',
  reviewComplete: 'Przegląd zakończony',
  issuesFound: 'Znaleziono %{count} problemów',
  draftTitle: 'Tworzenie dokumentu prawnego',
  draftPlaceholder: 'Edytuj tutaj lub poproś AI o wygenerowanie...',
  analyzingTemplate: 'Analiza szablonu %{name}...',
  templateAnalyzed: '✅ Szablon %{name} przeanalizowany! Powiedz, jak chcesz go zmienić.',
  templateAnalysisPrompt: 'Przeanalizuj kluczowe klauzule szablonu',
  parsingFailed: '⚠️ Nie udało się przeanalizować pliku, ale możesz opisać swoje potrzeby.',
  generating: 'Generowanie...',
  generatedSuccess: '✅ Dokument wygenerowany! Możesz go przeglądać i edytować.',
  drafterWelcome: 'Witaj w Asystencie dokumentów AI',
  drafterYouCan: 'Możesz:',
  drafterUploadTemplate: 'Przesłać szablon do analizy AI',
  drafterDescribeNeeds: 'Opisać wymagania dokumentu',
  drafterLetAiHelp: 'AI pomoże w tworzeniu umów, porozumień itp.',
  drafterExamples: 'Przykłady:',
  drafterExampleRental: '"Sporządź umowę najmu"',
  drafterExampleLabor: '"Wypełnij umowę o pracę według szablonu"',
  drafterInputPlaceholder: 'Opisz swoje potrzeby dokumentowe...',
  drafterThinking: 'Myślę...',
  drafterHistoryTitle: 'Historia',
  drafterNoHistory: 'Brak historii',
  drafterNewChat: 'Nowy czat',
  drafterHistory: 'Historia',
  drafterRemoveAttachment: 'Usuń załącznik',
  drafterLineHeight: 'Wysokość wiersza',
  drafterLineHeightSuffix: 'x',
  drafterExportWord: 'Eksport do Word (.docx)',
  drafterExportPdf: 'Eksport do PDF',
  drafterSave: 'Zapisz dokument',
  drafterDownload: 'Pobierz dokument',
  drafterUndo: 'Cofnij',
  drafterRedo: 'Ponów',
  drafterBold: 'Pogrubienie',
  drafterItalic: 'Kursywa',
  drafterStrike: 'Przekreślenie',
  drafterUnderline: 'Podkreślenie',
  drafterHighlight: 'Wyróżnienie',
  drafterLink: 'Wstaw link',
  drafterAlignLeft: 'Do lewej',
  drafterAlignCenter: 'Wyśrodkuj',
  drafterAlignRight: 'Do prawej',
  drafterAlignJustify: 'Wyjustuj',
  drafterList: 'Lista',
  drafterBulletList: 'Lista punktowana',
  drafterOrderedList: 'Lista numerowana',
  drafterTaskList: 'Lista zadań',
  drafterOpenResource: 'Otwórz panel zasobów',
  drafterStopGeneration: 'Zatrzymaj generowanie',
  drafterAgentMode: 'Tryb agenta aktywny | Kliknij aby przełączyć',
  drafterAgentModeOn: 'Tryb agenta aktywny',
  drafterAgentModeOff: 'Tryb normalny',
  drafterUploadAttachment: 'Prześlij załącznik',
  drafterExit: 'Wyjdź',
  drafterConfirm: 'Potwierdź',
  drafterOpenLink: 'Otwórz link',
  drafterDeleteLink: 'Usuń link',
  drafterQuote: 'Cytat',
  workflowTitle: 'Proces AI',
  workflowRunning: 'W trakcie...',
  workflowReady: 'Gotowy',
  workflowCompleted: 'Ukończony',
  workflowStartFailed: 'Nie udało się uruchomić procesu',
  workflowExecutionFailed: 'Wykonanie procesu nie powiodło się',
  workflowInterrupted: 'Proces przerwany',
  workflowProcessing: 'Przetwarzanie...',
  workflowStepsCompleted: 'kroków ukończono',
  workflowStepsTotal: 'Proces ukończony (%{count} kroków)',
  acceptChanges: 'Zaakceptuj zmiany',
  rejectChanges: 'Odrzuć zmiany',
  changesAccepted: 'Zmiany zaakceptowane',
  changesRejected: 'Zmiany odrzucone',
  stopWorkflow: 'Zatrzymaj',
  restartWorkflow: 'Restart',
  startDrafting: 'Rozpocznij tworzenie',
  interrupt: 'Zatrzymaj',
  documentSubject: 'Temat dokumentu *',
  documentType: 'Typ dokumentu',
  jurisdiction: 'Jurysdykcja',
  specialRequirements: 'Wymagania specjalne (opcjonalne)',
  clickStartDrafting: 'Kliknij "Rozpocznij tworzenie" aby uruchomić',
  docTypeContract: 'Umowa',
  docTypeAgreement: 'Porozumienie',
  docTypeNotice: 'Zawiadomienie',
  docTypeLetter: 'Pismo',
  docTypePetition: 'Petycja',
  docTypeWill: 'Testament',
  docTypePowerOfAttorney: 'Pełnomocnictwo',
  countryChina: 'Chiny',
  countryUSA: 'Stany Zjednoczone',
  countryGermany: 'Niemcy',
  countryJapan: 'Japonia',
  countryFrance: 'Francja',
  countryUK: 'Wielka Brytania',
  citationVerified: 'Zweryfikowany',
  citationUnverified: 'Niezweryfikowany',
  imageLoadFailed: 'Nie udało się załadować obrazu',
  smartDocTitle: 'Inteligentny asystent dokumentów',
  smartDocChatTitle: 'Asystent dokumentów AI',
  smartDocDropPrompt: 'Upuść plik PDF tutaj',
  smartDocSelectFile: 'Wybierz plik',
  smartDocOr: 'lub',
  smartDocWelcomeTitle: 'Witaj w Asystencie dokumentów AI',
  smartDocWelcomeYouCan: 'Możesz:',
  smartDocUploadForAI: 'Przesłać szablon do analizy',
  smartDocDescribeDoc: 'Opisać wymagania',
  smartDocLetAIDraft: 'AI pomoże w umowach',
  smartDocExamples: 'Przykłady:',
  smartDocExampleRental: '"Sporządź umowę najmu"',
  smartDocExampleLabor: '"Wypełnij umowę o pracę"',
  smartDocInputPlaceholder: 'Opisz potrzeby...',
  smartDocRemoveAttachment: 'Usuń załącznik',
  smartDocOpenResources: 'Otwórz zasoby',
  smartDocExit: 'Wyjdź',
  reviewStartFailed: 'Uruchomienie przeglądu nie powiodło się',
  reviewFailed: 'Przegląd nie powiódł się',
  reviewFoundIssues: 'Przegląd zakończony, %{count} problemów.',
  cannotReadStream: 'Nie można odczytać strumienia',
  parseEventFailed: 'Nie można przeanalizować zdarzenia',
  errorPrefix: 'Błąd',
  unknownError: 'Nieznany błąd',
  file: 'Plik',
  loading: 'Ładowanie...',
  localFolders: 'Lokalne foldery',
  selectLocalFolder: 'Wybierz folder lokalny',
  reselectFolder: 'Zmień folder',
  addToContext: 'Dodaj do czatu',
  saveFile: 'Zapisz',
  renameFile: 'Zmień nazwę',
  fileSaved: 'Plik zapisany',
  fileRenamed: 'Plik zmieniony na %{name}',
  browserNotSupported: 'Twoja przeglądarka nie obsługuje dostępu do folderów',
  noFolderSelected: 'Wybierz folder lokalny',
  scanningFolder: 'Skanowanie folderu...',
  selectFileToPreview: 'Wybierz plik do podglądu',
  aiAnalyze: 'Analiza AI',
};
